import type * as React from "react";
import { type FC, useCallback, useState } from "react";

import { TextField } from "~/common/mui";
import { sendResetPasswordRequest } from "~/features/auth/login/api/ResetPassword";
import { useInputState } from "~/common/hooks/useInputState";
import { useTranslation } from "react-i18next";

interface Props {
  initialEmail?: string;
  onSuccess: (globalErrors: string[]) => void;
  disableEdit?: boolean;
}

const EMAIL_FIELD_NAME = "email";

const ResetPasswordForm: FC<Props> = ({ initialEmail, onSuccess, disableEdit }) => {
  const { t } = useTranslation();

  const [email, onEmailChange] = useInputState(initialEmail);
  const [validationError, setValidationError] = useState("");

  const onSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();

      try {
        const data = await sendResetPasswordRequest(email);
        const requestHasErrors =
          data.validationResults[EMAIL_FIELD_NAME] || (data.globalErrors && data.globalErrors.length > 0);
        if (requestHasErrors) {
          if (data.validationResults[EMAIL_FIELD_NAME]) {
            setValidationError(data.validationResults[EMAIL_FIELD_NAME][0]);
          }
        } else {
          onSuccess(data.globalErrors);
        }
      } catch (err) {
        if (err instanceof Error) {
          setValidationError(err.message);
        }
      }
    },
    [email, onSuccess],
  );

  return (
    <>
      <p className={"mt-0 mb-3 forgot-password-description"}>{t("forgottenPwd.description")}</p>
      <form id="reset-password" onSubmit={onSubmit} className={"scha__reset-password-form"}>
        <div className={"mb-30 forgot-email-field"}>
          <TextField
            fullWidth
            label={t("forgottenPwd.email.label")}
            inputProps={{ "data-test-id": "reset-email-input" }}
            name={EMAIL_FIELD_NAME}
            value={email}
            onChange={onEmailChange}
            error={!!validationError}
            helperText={t(validationError)}
            disabled={disableEdit}
          />
        </div>
      </form>
    </>
  );
};

export default ResetPasswordForm;
